// import React from 'react';
// import classes from "./ZipGameHistory.module.css";
// import Header from '../../components/Header';
// import BottomNavbar from '../../components/BottomNavbar';
// import { useEffect } from 'react';
// import { zipUserHistoryApi } from '../../http/http';
// import { useSelector } from 'react-redux';

// const ZipGameHistory = () => {

//     const { userZip } = useSelector(
//         (state) => state?.persisted?.userZipGameTokenSlice
//     );

//     const fetchHistory = async () => {
//         try {
//             const response = await zipUserHistoryApi(page, userZip?.token);
//             console.log(response, 'respons-e-');
//         } catch (error) {
//             console.log(error, 'error-');
//         }
//     }
//     useEffect(() => {
//         fetchHistory();
//     }, []);
//     return (
//         <>
//             <Header />
//             <div className={classes.container}>

//             </div>
//             <BottomNavbar active={null} />
//         </>
//     )
// }

// export default ZipGameHistory


import React, { useEffect, useMemo, useState } from "react";
import classes from "./ZipGameHistory.module.css";
import Header from "../../components/Header";
import BottomNavbarZipGame from "../../components/ZipGame/BottomNavbarZipGame";
import { useSelector } from "react-redux";
import { zipUserHistoryApi } from "../../http/http";
import { useNavigate } from "react-router-dom";
import {
    FaArrowLeft,
    FaChevronLeft,
    FaChevronRight,
    FaCalendarDays,
    FaStopwatch,
    FaGamepad,
    FaBolt,
} from "react-icons/fa6";
import { useTranslation } from "react-i18next";

const ZipGameHistory = () => {
    const navigate = useNavigate();

    const {t}=useTranslation();

    const { userZip } = useSelector(
        (state) => state?.persisted?.userZipGameTokenSlice
    );

    const [page, setPage] = useState(1);
    const [historyData, setHistoryData] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");

    const fetchHistory = async () => {
        try {
            setLoading(true);
            setErrorMessage("");

            const response = await zipUserHistoryApi(page, userZip?.token);
            const result = response?.data?.result || {};

            setHistoryData(result?.data || []);
            setTotalPages(result?.totalPages || 1);
            setCurrentPage(result?.currentPage || 1);
            setTotalRecords(result?.totalRecords || 0);
        } catch (error) {
            console.log(error, "error-");
            setErrorMessage(t("241"));
            setHistoryData([]);
            setTotalPages(1);
            setCurrentPage(1);
            setTotalRecords(0);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (userZip?.token) {
            fetchHistory();
        }
    }, [page, userZip?.token]);

    const formatDuration = (seconds) => {
        const totalSeconds = Number(seconds) || 0;

        const mins = Math.floor(totalSeconds / 60);
        const secs = totalSeconds % 60;

        if (mins > 0) {
            return `${mins}m ${secs}s`;
        }

        return `${secs}s`;
    };

    const formatDateTime = (dateString) => {
        if (!dateString) return "-";

        const date = new Date(dateString);

        if (isNaN(date.getTime())) return "-";

        return date.toLocaleString("en-US", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            // hour: "2-digit",
            // minute: "2-digit",
        });
    };

    const visiblePages = useMemo(() => {
        const pages = [];
        const start = Math.max(1, currentPage - 1);
        const end = Math.min(totalPages, currentPage + 1);

        for (let i = start; i <= end; i += 1) {
            pages.push(i);
        }

        if (currentPage === 1 && totalPages > 3) {
            return [1, 2, 3];
        }

        if (currentPage === totalPages && totalPages > 3) {
            return [totalPages - 2, totalPages - 1, totalPages];
        }

        return pages;
    }, [currentPage, totalPages]);

    return (
        <>
            <Header />

            <div className={classes.container}>
                <div className={classes.header_section}>
                    <button
                        className={classes.back_button}
                        onClick={() => navigate(-1)}
                        type="button"
                    >
                        <FaArrowLeft className={classes.back_icon} />
                    </button>

                    <p className={classes.header_title}>{t("242")}</p>
                </div>

                {/* <div className={classes.hero_card}>
                    <div className={classes.hero_glow_one}></div>
                    <div className={classes.hero_glow_two}></div>

                    <div className={classes.hero_top}>
                        <div>
                            <p className={classes.hero_label}>Zip Game Activity</p>
                            <h2 className={classes.hero_heading}>Track every puzzle you played</h2>
                            <p className={classes.hero_subtext}>
                                View your recent matches, moves, time taken and play date.
                            </p>
                        </div>
                    </div>

                    <div className={classes.stats_grid}>
                        <div className={classes.stat_card}>
                            <div className={classes.stat_icon}>
                                <FaGamepad />
                            </div>
                            <div>
                                <p className={classes.stat_label}>Total Games</p>
                                <p className={classes.stat_value}>{totalRecords}</p>
                            </div>
                        </div>

                        <div className={classes.stat_card}>
                            <div className={classes.stat_icon}>
                                <FaBolt />
                            </div>
                            <div>
                                <p className={classes.stat_label}>Current Page</p>
                                <p className={classes.stat_value}>{currentPage}</p>
                            </div>
                        </div>

                        <div className={classes.stat_card}>
                            <div className={classes.stat_icon}>
                                <FaCalendarDays />
                            </div>
                            <div>
                                <p className={classes.stat_label}>Total Pages</p>
                                <p className={classes.stat_value}>{totalPages}</p>
                            </div>
                        </div>
                    </div>
                </div> */}

                <div className={classes.history_section}>
                    <div className={classes.section_top}>
                        <p className={classes.section_title}>{t("243")}</p>
                        <span className={classes.section_badge}>{totalRecords} {t("244")}</span>
                    </div>

                    {loading ? (
                        <div className={classes.loading_wrap}>
                            <div className={classes.loader}></div>
                            <p>{t("245")}</p>
                        </div>
                    ) : errorMessage ? (
                        <div className={classes.empty_state}>
                            <p className={classes.empty_title}>{t("86")}</p>
                            <p className={classes.empty_text}>{errorMessage}</p>
                            <button
                                type="button"
                                className={classes.retry_btn}
                                onClick={fetchHistory}
                            >
                                {t("246")}
                            </button>
                        </div>
                    ) : historyData?.length === 0 ? (
                        <div className={classes.empty_state}>
                            <p className={classes.empty_title}>{t("247")}</p>
                            <p className={classes.empty_text}>
                                {t("248")}
                            </p>
                        </div>
                    ) : (
                        <>
                            <div className={classes.history_list}>
                                {historyData.map((item, index) => (
                                    <div className={classes.history_card} key={item?.id || index}
                                        onClick={() => navigate("/zip-game/game-details", {
                                            state: {
                                                game: item
                                            }
                                        })}
                                    >
                                        <div className={classes.history_card_top}>
                                            <div className={classes.left_block}>
                                                <div className={classes.game_index}>
                                                    #{(currentPage - 1) * 10 + index + 1}
                                                </div>

                                                <div className={classes.game_main_info}>
                                                    <p className={classes.game_title}>{t("249")}</p>
                                                    <p className={classes.game_id}>
                                                        {t("250")} {item?.game_trx_id || "-"}
                                                    </p>
                                                </div>
                                            </div>

                                            <span className={classes.status_badge}>
                                                {item?.status === 1 ? t("251") : t("252")}
                                            </span>
                                        </div>

                                        <div className={classes.history_meta_grid}>
                                            <div className={classes.meta_item}>
                                                <div className={classes.meta_icon}>
                                                    <FaStopwatch />
                                                </div>
                                                <div>
                                                    <p className={classes.meta_label}>{t("253")}</p>
                                                    <p className={classes.meta_value}>
                                                        {formatDuration(item?.total_time_seconds)}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className={classes.meta_item}>
                                                <div className={classes.meta_icon}>
                                                    <FaBolt />
                                                </div>
                                                <div>
                                                    <p className={classes.meta_label}>{t("254")}</p>
                                                    <p className={classes.meta_value}>{item?.moves ?? 0}</p>
                                                </div>
                                            </div>

                                            <div className={`${classes.meta_item} ${classes.full_width}`}>
                                                <div className={classes.meta_icon}>
                                                    <FaCalendarDays />
                                                </div>
                                                <div>
                                                    <p className={classes.meta_label}>{t("255")}</p>
                                                    <p className={classes.meta_value}>
                                                        {formatDateTime(item?.datetime)}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className={classes.pagination_wrap}>
                                <button
                                    type="button"
                                    className={classes.page_nav_btn}
                                    disabled={currentPage === 1}
                                    onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                                >
                                    <FaChevronLeft />
                                </button>

                                <div className={classes.page_numbers}>
                                    {visiblePages.map((item) => (
                                        <button
                                            key={item}
                                            type="button"
                                            className={`${classes.page_number_btn} ${currentPage === item ? classes.active_page : ""
                                                }`}
                                            onClick={() => setPage(item)}
                                        >
                                            {item}
                                        </button>
                                    ))}
                                </div>

                                <button
                                    type="button"
                                    className={classes.page_nav_btn}
                                    disabled={currentPage === totalPages || totalPages === 0}
                                    onClick={() =>
                                        setPage((prev) => Math.min(prev + 1, totalPages))
                                    }
                                >
                                    <FaChevronRight />
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>

            <BottomNavbarZipGame active={null} />
        </>
    );
};

export default ZipGameHistory;